import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/authSlice';
import { pickingApi } from './api/pickingApi';
import { stocktakeApi } from './api/stocktakeApi';

const store = configureStore({
  reducer: {
    auth: authReducer,
    [pickingApi.reducerPath]: pickingApi.reducer,
    [stocktakeApi.reducerPath]: stocktakeApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(pickingApi.middleware, stocktakeApi.middleware),
});

export default store;